(function () {
    'use strict';

    angular
        .module('riskModule')
        .controller('grcRiskFullController', Controller);

    Controller.$inject = ['$scope', 'grcRiskService', 'grcGovernanceProcessService'];

    function Controller($scope, grcRiskService, grcGovernanceProcessService) {

        // Custom Information
        grcRiskService.getAllRiskTypes()
            .then(function (riskTypes) {
                $scope.riskTypes = riskTypes;
            });

        grcGovernanceProcessService.getActiveRiskSelfAssessments()
            .then(function (governanceProcess) {
                $scope.governanceProcess = governanceProcess;
            });

        // Get Possible Parent Risks
        if (!_.isUndefined($scope.boxModel) && !_.isUndefined($scope.boxModel.RiskLevel) &&
            !$scope.boxModel.RiskLevel.IsTopRisk) {

            var currentRiskLevel = $scope.boxModel.RiskLevel;

            grcRiskService
                .getAllActiveRisks({ ignoreError: true })
                .then(function (activeRisks) {
                    if (currentRiskLevel.IsDepartmentRisk) {
                        // Get key risks
                        $scope.ctxtDir.possibleParentRisks = _.filter(activeRisks, { RiskLevel: { IsKeyRisk: true } });
                    } else if (currentRiskLevel.IsKeyRisk) {
                        // Get top risks
                        $scope.ctxtDir.possibleParentRisks = _.filter(activeRisks, { RiskLevel: { IsTopRisk: true } });
                    }
                });
        }
    }
})();